import { render, staticRenderFns } from "./MetaPostMessage.vue?vue&type=template&id=60946e69&scoped=true"
import script from "./MetaPostMessage.vue?vue&type=script&lang=js"
export * from "./MetaPostMessage.vue?vue&type=script&lang=js"
import style0 from "./MetaPostMessage.vue?vue&type=style&index=0&id=60946e69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60946e69",
  null
  
)

export default component.exports